import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
const GeneralModal = ({
  title,
  children, //TODO: user children for body,
  showXIcon = true,
  onClose,
  onSubmit,
  submitTitle = 'Ok',
  cancelTitle,
  showCancelBtn = true,
  showSubmitBtn = true,
  btnType = 'save',
  disableSubmit,
}) => {
  const {t} = useTranslation();
  return (
    <div className='modal'>
      <div className='modal__content'>
        <div className='modal__content-head'>
          {title && <p>{title}</p>}
          {showXIcon && (
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={onClose}
            />
          )}
        </div>
        <div
          className='modal__content-body'
          style={{display: 'flex', justifyContent: 'center'}}
        >
          {children}
        </div>
        <div className='modal__content-bottom'>
          {showCancelBtn && (
            <button className='close' onClick={onClose}>
              {cancelTitle ? cancelTitle : t('generalModal.cancel')}
            </button>
          )}
          {showSubmitBtn && (
            <button
              className={`${disableSubmit ? 'disabled' : `${btnType}`}`}
              onClick={onSubmit}
              disabled={disableSubmit}
            >
              {submitTitle}
            </button>
          )}
        </div>
      </div>
      <div className='modal__bg' onClick={onClose}></div>
    </div>
  );
};

export default GeneralModal;
